export default __webpack_public_path__ + "static/media/voyages.a750e2c8.png";